"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayBoardTemplate = void 0;
const button_1 = require("../../../view-components/buttons/button");
require("./start.scss");
const playUI_1 = require("./playboard/playUI");
const start_game_1 = require("./start-game");
const gameplay_1 = require("./playboard/gameplay");
class PlayBoardTemplate {
    constructor(id) {
        this.playBoardHTML = document.createElement('div');
        this.playBoardHTML.id = id;
        this.play = new playUI_1.PlayUI('game');
    }
    render() {
        const gamePlay = this.play.render('Level1', 0);
        const buttonStart = button_1.ButtonEl.render('start-button', 'Start');
        const buttonBar = document.createElement('div');
        buttonBar.className = 'button-bar';
        buttonBar.id = 'button-bar';
        const buttonCheck = button_1.ButtonEl.render('check-level-button', 'Check');
        const buttonAutoComplete = button_1.ButtonEl.render('auto-complete-button', 'Auto-Complete');
        buttonCheck.classList.add('disabled');
        buttonStart.addEventListener('click', start_game_1.handleClickStart);
        buttonCheck.addEventListener('click', gameplay_1.handleCheckString);
        buttonAutoComplete.addEventListener('click', gameplay_1.autoCompleteAnswer);
        const autoCompleteCounts = document.createElement('div');
        autoCompleteCounts.className = 'auto-complete-counter';
        const counter = document.createElement('span');
        counter.id = 'counter';
        counter.innerText = '0';
        autoCompleteCounts.innerText = 'Count: ';
        autoCompleteCounts.append(counter);
        buttonAutoComplete.append(autoCompleteCounts);
        buttonBar.append(buttonCheck);
        buttonBar.append(buttonAutoComplete);
        this.playBoardHTML.append(buttonStart);
        this.playBoardHTML.append(gamePlay);
        this.playBoardHTML.append(buttonBar);
        return this.playBoardHTML;
    }
}
exports.PlayBoardTemplate = PlayBoardTemplate;
